export default "__VITE_ASSET__C3TsvJU4__"